/**
 * アクセスポリシー画面の選択肢とラベル(`server/app/idp/constants.py` と同じ値)。
 *
 * **真実はサーバー側**。原子の一覧と上限は `GET /api/idp/policy/atoms` が返すので、
 * ここに持つのは絞り込みの選択肢と、画面の初期値だけ。
 */
export const DECISION_ALLOW = "allow";
export const DECISION_DENY = "deny";
export const DECISION_REQUIRE_OTP = "require_otp";

/** 判定ログに出るのは拒否と追加認証だけ(許可はアクセスログに出る)。 */
export const DECISION_OPTIONS = [
  { value: DECISION_DENY, label: "拒否" },
  { value: DECISION_REQUIRE_OTP, label: "追加認証" },
];

export function decisionColor(decision: string): string {
  if (decision === DECISION_DENY) return "red";
  if (decision === DECISION_REQUIRE_OTP) return "orange";
  return "green";
}

/** 条件式の初期値(サーバー側の既定と同じ)。 */
export const ALLOW_DEFAULT = "always";
export const OTP_SKIP_DEFAULT = "always";
export const OTP_SETUP_DEFAULT = "never";
export const COOKIE_TTL_DEFAULT = 168;
export const COOKIE_TTL_MIN = 1;
export const COOKIE_TTL_MAX = 8760;

/** 貼り付け欄の見本(1 行 1 件。`,` や空白区切りでも受け付ける)。 */
export const ENTRIES_PLACEHOLDER = `203.0.113.10
203.0.113.0/24
2001:db8::/32`;

/** IP グループの一括取込の上限(サーバー側と同じ)。 */
export const ENTRIES_MAX = 100;
